/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import Colors from '@global/colors';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import Modal from '@components/modal/Modal';
import Button from '@components/form/Button';
import { hideDiscard } from '@/store/global';
import { isWeb } from '@global/screens';

const Discard = () => {
  const dispatch = useDispatch();
  const showDiscard = useSelector((state) => state.global.showDiscard);

  const show = showDiscard.show;
  const title = showDiscard.title;
  const description = showDiscard.description;
  const buttons = showDiscard.buttons;

  return (
    <Modal
      testID="discard-modal"
      transparent={true}
      visible={show}
      animationType="fade"
      needTop={true}
      closeOutside={false}
      onClose={() => dispatch(hideDiscard())}>
      <View style={styles.discard}>
        <View style={styles.top}>
          <SociollaText
            testID="discard-modal-title"
            type="medium"
            style={styles.title}
            ellipsizeMode="tail"
            numberOfLines={1}>
            {title}
          </SociollaText>
          <TouchableOpacity
            testID="discard-modal-close-btn"
            onPress={() => dispatch(hideDiscard())}>
            <Image
              width={13}
              height={13}
              style={{ width: 13, height: 13, marginTop: -6 }}
              svg={true}
              source={require('@assets/img/icons/close-grey.svg')}
            />
          </TouchableOpacity>
        </View>
        {description ? (
          <View style={styles.description}>
            <SociollaText
              testID="discard-modal-description"
              style={styles.descriptionText}>
              {description}
            </SociollaText>
          </View>
        ) : (
          false
        )}
        {buttons && buttons.length ? (
          <View style={styles.buttons}>
            {buttons.map((item, idx) => (
              <Button
                testID={`discard-modal-btn-${(item.text || idx)
                  .toString()
                  .toLowerCase()
                  .replace(/\s+/g, '-')}`}
                key={idx}
                type={item.type}
                rounded={true}
                buttonStyle={item.style}
                title={
                  <SociollaText
                    type="bold"
                    style={[styles.buttonText, { color: item.textColor }]}>
                    {item.text}
                  </SociollaText>
                }
                onPress={() => item.callback()}
              />
            ))}
          </View>
        ) : (
          false
        )}
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  discard: {
    position: 'absolute',
    top: 200,
    backgroundColor: Colors.white,
    width: 260,
    alignSelf: 'center',
    borderRadius: 3,
    paddingTop: 20,
    paddingBottom: 20,
    paddingHorizontal: 20,
  },
  top: {
    marginBottom: 15,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: { fontSize: 14, width: 220 },
  description: { marginBottom: 30 },
  descriptionText: { fontSize: 12, lineHeight: 18 },
  buttons: {
    width: '100%',
    flexDirection: isWeb ? 'row' : 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  buttonText: {
    fontSize: 14,
    letterSpacing: 0.5,
  },
});

export default Discard;
